var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-143.5%",
    y: "-168.8%",
    width: "387%",
    height: "512.5%",
    filterUnits: "objectBoundingBox",
    id: "Sort_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.229949097 0 0 0 0 0.461254077 0 0 0 0 0.62647192 0 0 0 0.0533333333 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.231372549 0 0 0 0 0.462745098 0 0 0 0 0.62745098 0 0 0 0.0266666667 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Sort_svg__[object_Object]b",
    x: 192,
    y: 0,
    width: 92,
    height: 64,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-227 -12)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#Sort_svg__[object_Object]a)",
    xlinkHref: "#Sort_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#EBEBEB",
    strokeLinejoin: "square",
    x: 192.5,
    y: 0.5,
    width: 91,
    height: 63,
    rx: 8
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Manrope_SemiBold, Manrope",
    fontSize: 12,
    fontWeight: 500,
    fill: "#212A36",
    transform: "translate(-227 -12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 212.476,
    y: 44
  }, "Sorteren")), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    transform: "translate(1 1)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.2V3m-3.75 9.6l3.308 3.424a.638.638 0 00.442.176.638.638 0 00.442-.176l3.308-3.424"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.6,
    width: 7.5,
    height: 7.2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 18.6c-.69 0-1.25-.537-1.25-1.2m0-4.8c0-.663.56-1.2 1.25-1.2m5 7.2c.69 0 1.25-.537 1.25-1.2m0-4.8c0-.663-.56-1.2-1.25-1.2M3.75 18.6H5m-1.25-7.2H5m-4.375 3v1.2m7.5-1.2v1.2"
  })))));
}
export default SvgSort;